import cssUtil from 'gw-portals-util-js/CssUtil';
import _ from 'lodash';
import styles from './GuidanceRecommendations-hashed.scss';
import templateStr from 'text!./GuidanceRecommendations.html';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            continueToNextPanel: '&',
            recommendations: '=',
            accountNumber: '=',
            displayInfo: '&',
            isSelectedProduct: '&',
            callback: '&',
            isProductAvailable: '&',
            isProductSelected: '&'
        },
        template: cssUtil.hashTemplate(templateStr, styles),
        controller: ['$scope', 'guidance.DynamicContent', function ($scope, dynamicContent) {
            var THROTTLE_TIME = 300;

            $scope.getState = function (recommendation) {
                return $scope.isSelectedProduct({ product: recommendation }) ? 'Completed' : 'Selectable';
            };

            $scope.selectedProduct = {};
            $scope.updateSelectedProduct = function (recommendation) {
                $scope.selectedProduct = recommendation.value;
                $scope.callback({ product: recommendation });
            };

            $scope.updateSelectionAndContinueToFullQuote = _.throttle(function (recommendation) {
                if ($scope.isProductAvailable({ selectedProduct: recommendation })) {
                    $scope.updateSelectedProduct(recommendation);
                    $scope.transitionToFullQuotePromise = $scope.continueToNextPanel();
                }
            }, THROTTLE_TIME);

            $scope.getIcon = dynamicContent.getProductCodeIcon;
            $scope.getCustomImage = dynamicContent.getProductCodeImage;
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/guidance/common/directives/Recommendations/GuidanceRecommendations.js
// module id = 962
// module chunks = 0